import AoReason from './AoReason';
import AoReasonForm from './AoReasonForm';


const AoReasonConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/aoReason',
      element: <AoReason />,
    },
    {
      path: '/addAoReason',
      element: <AoReasonForm />,
    },
    {
      path: '/editAoReason/:id',
      element: <AoReasonForm/>,
    },
  ],
};

export default AoReasonConfig;
